import { Button } from '@change/ds-core-ui';
import { cn } from '@change/ds-utils';

import { ShareSlideUp } from '../../../PageBody/components/PromoteOrShareActions/components/ShareSlideUp';
import { usePromoteOrShareActions } from '../../../PageBody/components/PromoteOrShareActions/hooks/usePromoteOrShareActions';

export const ShareButton: React.FC = () => {
	const {
		data: {
			isShareSlideUpEnabled,
			shareButtonLabel,
			shareButtonVariant,
			shareButtonUrl,
			advocateEntryPointExperiment,
			advocateEntryPointUrl,
			advocateEntryPointButtonLabel,
		},
		actions: { handleShareClick, handleAdvocateEntryPointClick },
	} = usePromoteOrShareActions();

	if (advocateEntryPointExperiment) {
		return (
			<Button
				as="a"
				variant="tertiary"
				href={advocateEntryPointUrl}
				onClick={handleAdvocateEntryPointClick}
				className="w-full py-3 text-center"
				data-qa="advocate-button"
				data-testid="advocate-button"
			>
				{advocateEntryPointButtonLabel}
			</Button>
		);
	}
	return (
		<>
			{isShareSlideUpEnabled && (
				/* The share slide-up is only visible on mobile. */
				<ShareSlideUp shareButtonLabel={shareButtonLabel} buttonVariant={shareButtonVariant} />
			)}
			{/* The share button is hidden on mobile to leverage the slide-up. */}
			<Button
				as="a"
				variant={shareButtonVariant}
				href={shareButtonUrl}
				onClick={handleShareClick}
				className={cn('w-full py-3 text-center', { 'hidden md:block': isShareSlideUpEnabled })}
				data-qa="share-button"
				data-testid="share-button"
			>
				{shareButtonLabel}
			</Button>
		</>
	);
};
